<!-- Main Page Heading Start -->
<div [ngClass]="{'show-login-as-client': (showClientBanner&&(!maintenanceStartWarning||!isMaintenancModeOn)) || (!showClientBanner&&(maintenanceStartWarning||isMaintenancModeOn)),
'show-login-as-client2':  showClientBanner&&(maintenanceStartWarning||isMaintenancModeOn)}">
    <div class="sticky-header-wrapper" >
    <div class="main-page-heading text-center sticky-header-queue ">
        <div class="row mx-0 gutters-8 module-header-info font-size-12 text-left">
            <div class="col-2 client-block">
                <div class="module-info-item">
                    <span class="label-banner">{{'Lendisoft Client' | translate}}</span><strong class="wrap-text" *ngIf="clientInfo && clientInfo.name.length <=25">{{ clientInfo.name | titlecase }}</strong><strong class="wrap-text" title="{{ clientInfo.name | titlecase }}" *ngIf="clientInfo && clientInfo.name.length > 25">{{ clientInfo.name | titlecase | slice:0:25  }}...</strong>
                </div>
                <div class="module-info-item">
                    <span class="label-banner">{{'Source/Dealership'| translate}}</span>
                    <ng-container *ngIf="loanDetail?.source_company">
                        <strong class="wrap-text" *ngIf="loanDetail?.source_company.length <= 25">{{ loanDetail?.source_company | titlecase  }}</strong>
                        <strong class="wrap-text" title="{{ loanDetail?.source_company | titlecase  }}" *ngIf="loanDetail?.source_company.length > 25">{{ loanDetail?.source_company |titlecase |slice:0:25 }}...</strong>
                    </ng-container>
                </div>
            </div>
            <div class="col-2 loan-id">
                <div class="module-info-item">
                    <span class="label-banner">
                    <img class="label-banner"  title="{{'copy'|translate}}" style="max-width: 15px; cursor: pointer;" src="../assets/images/icons-copy.png" alt="" (click)="getLoanIdToCopy()" />
                    {{'Loan ID'| translate}}</span>
                    <ng-container *ngIf="loanDetail?.loan_id">
                        <div class="wrap-text wrap-text-3 d-inline-block">
                            <strong *ngIf="loanDetail?.loan_id.length <= 25">{{ loanDetail?.loan_id  }}</strong>
                            <strong  title="{{ loanDetail?.loan_id  }}" *ngIf="loanDetail?.loan_id.length > 25" >{{ loanDetail?.loan_id |slice:0:25 }}...</strong>
                            <!-- <img class="icon-light label-banner" title="copy" style="max-width: 15px; cursor: pointer;" src="../assets/images/icons-copy.png" alt="" (click)="getLoanIdToCopy()" /> -->
                        </div>
                    </ng-container>
                </div>
                <div class="module-info-item">
                    <span class="label-banner">{{'Loan Status'|translate}}</span>
                    <div class="status-activity">
                    <ng-container *ngIf="loanDetail?.sub_status_label && loanDetail?.sub_status_label.length <= 15">
                        <strong class="wrap-text wrap-text-3">{{loanDetail?.status ? loanDetail?.status.replace('-', ' ') : '' }}
                        {{(loanDetail?.sub_status_label=='' || loanDetail?.sub_status_label==null)?'':'-' }}
                        {{(loanDetail?.sub_status_label || '') }}
                        </strong>
                    </ng-container>
                    <ng-container *ngIf="loanDetail?.sub_status_label && loanDetail?.sub_status_label.length > 15">
                        <strong class="wrap-text wrap-text-3" title="{{loanDetail?.status ? loanDetail?.status.replace('-', ' ') : '' }} {{(loanDetail?.sub_status_label=='' || loanDetail?.sub_status_label==null)?'':'-' }} {{(loanDetail?.sub_status_label || '') }}"  >{{loanDetail?.status ? loanDetail?.status.replace('-', ' ') : '' }}
                        {{(loanDetail?.sub_status_label=='' || loanDetail?.sub_status_label==null)?'':'-' }}
                        <ng-container *ngIf="loanDetail?.sub_status_label.length <= 15" >{{(loanDetail?.sub_status_label || '') }}</ng-container>
                        <ng-container *ngIf="loanDetail?.sub_status_label.length > 15" >{{ ((loanDetail?.sub_status_label| slice:0:15) || '') }}...</ng-container>
                        </strong>
                    </ng-container>
                    </div>
                </div>
            </div>
            <div class="col-2 applicant-block">
                <div class="module-info-item">
                    <span class="label-banner">{{'Applicant'| translate}}</span><strong class="wrap-text" *ngIf="[loanDetail?.applicant?.firstname,loanDetail?.applicant?.middlename,loanDetail?.applicant?.lastname].join(' ').length <= 25 " >{{ loanDetail?.applicant?.firstname | titlecase }}
                    {{ loanDetail?.applicant?.middlename | titlecase }}
                    {{ loanDetail?.applicant?.lastname | titlecase }}
                    {{ loanDetail?.applicant?.suffix_display }}
                </strong>
                    <strong class="wrap-text" *ngIf="[loanDetail?.applicant?.firstname,loanDetail?.applicant?.middlename,loanDetail?.applicant?.lastname].join(' ').length > 25 " title="{{ [loanDetail?.applicant?.firstname,loanDetail?.applicant?.middlename,loanDetail?.applicant?.lastname].join(' ') | titlecase }}" >{{ [loanDetail?.applicant?.firstname,loanDetail?.applicant?.middlename,loanDetail?.applicant?.lastname].join(' ') | titlecase |slice:0:25 }}...</strong>
                </div>
                <div class="module-info-item">
                    <span class="label-banner">{{'Co-Applicant'| translate}}</span><strong class="wrap-text" *ngIf="[loanDetail?.co_applicant?.firstname,loanDetail?.co_applicant?.middlename,loanDetail?.co_applicant?.lastname].join(' ').length <= 25 ">{{ loanDetail?.co_applicant?.firstname | titlecase }}
                    {{ loanDetail?.co_applicant?.middlename | titlecase }}
                    {{ loanDetail?.co_applicant?.lastname | titlecase }} 
                    {{ loanDetail?.co_applicant?.suffix_display}} 
                </strong>
                    <strong class="wrap-text" *ngIf="[loanDetail?.co_applicant?.firstname,loanDetail?.co_applicant?.middlename,loanDetail?.co_applicant?.lastname].join(' ').length > 25" title="{{ [loanDetail?.co_applicant?.firstname,loanDetail?.co_applicant?.middlename,loanDetail?.co_applicant?.lastname].join(' ')|titlecase }}">{{ [loanDetail?.co_applicant?.firstname,loanDetail?.co_applicant?.middlename,loanDetail?.co_applicant?.lastname].join(' ')|titlecase |slice:0:25}} ...</strong>
                </div>
            </div>
            <div class="col-2 pre-phone">
                <div class="module-info-item">
                    <span class="label-banner">{{'Preferred Phone'| translate}}</span><strong class="wrap-text2">{{ getPreferredNo("applicant") | mask: US_PHONE_MASKING }}</strong>
                </div>
                <div class="module-info-item">
                    <span class="label-banner">{{'Preferred Phone'| translate}}</span><strong class="wrap-text2">{{ getPreferredNo("co_applicant") | mask: US_PHONE_MASKING }}</strong>
                </div>
            </div>
            <div class="col-2 assigned-block">
                <div  class="module-info-item">
                    <span class="label-banner">{{'Assigned To'| translate}}</span>
                    <strong class="wrap-text" *ngIf="[loanDetail?.assignee?.firstname,loanDetail?.assignee?.lastname].join(' ').length <= 25" >{{ [loanDetail?.assignee?.firstname,loanDetail?.assignee?.lastname].join(' ') |titlecase }}</strong>
                    <strong class="wrap-text" *ngIf="[loanDetail?.assignee?.firstname,loanDetail?.assignee?.lastname].join(' ').length > 25 " title="{{[loanDetail?.assignee?.firstname,loanDetail?.assignee?.lastname].join(' ') |titlecase }}">{{ [loanDetail?.assignee?.firstname,loanDetail?.assignee?.lastname].join(' ')|titlecase|slice:0:25  }}...</strong>
                </div>
                <div  class="module-info-item">
                    <span class="label-banner">{{'Routed To'| translate}}</span>
                    <strong class="wrap-text" *ngIf="[loanDetail?.routed?.firstname,loanDetail?.routed?.lastname].join(' ').length <= 25">{{ loanDetail?.routed?.firstname | titlecase }} {{ loanDetail?.routed?.lastname| titlecase }}</strong>
                    <strong class="wrap-text"  *ngIf="[loanDetail?.routed?.firstname,loanDetail?.routed?.lastname].join(' ').length > 25" title="{{ [loanDetail?.routed?.firstname,loanDetail?.routed?.lastname].join(' ') |titlecase }}">{{ [loanDetail?.routed?.firstname,loanDetail?.routed?.lastname].join(' ')|titlecase | slice:0:25 }}...</strong>

                </div>
                <!-- <div *ngIf="loanDetail?.routed?.firstname==null||''" class="module-info-item">
                    <span class="text-right">Routed To</span><strong>{{ loanDetail?.assignee?.firstname }}
                    {{ loanDetail?.assignee?.lastname }}</strong>
                </div> -->
            </div>
        </div>
          <!-- Page Menubar Start -->
      <div class="page-menubar">
        <div class="row">
          <div class="col-lg-auto">
            <!-- <a data-toggle="collapse" class="collapsed" aria-expanded="true" href="javascript:;" data-target="#sidebar"
              role="button">
              <img class="icon-light" src="../assets/images/icons/hamburger-icon-dark.png" />
              <img class="icon-dark" src="../assets/images/icons/hamburger-icon.png" />
            </a> -->
          </div>
          <div class="col-lg">
            <div class="page-menu-actions">
              <a [class.active]="validateRoute('home')" (click)="goToRoute('home')" *ngIf="isaccount_homeCanAccess">{{'Account Home' | translate}}</a>
              <a [class.active]="validateRoute('applicant-information')"
                (click)="goToRoute('applicant-information')" *ngIf="isapplicantCanAccess">{{'Applicant Information' | translate}}</a>
              <a [class.active]="validateRoute('transactions')" (click)="goToRoute('transactions')" *ngIf="istransactionsCanAccess">{{'Transactions' | translate}}</a>
              <a [class.active]="validateRoute('loan-info')" (click)="goToRoute('loan-info')" *ngIf="isloan_informationCanAccess || canAccessSideNotes || canAccessDownPayments">{{'Loan Information' | translate}}</a>
              <a [class.active]="validateRoute('activity-notes')" (click)="goToRoute('activity-notes')" *ngIf="isactivity_notesCanAccess">{{'Activity Notes' | translate}}</a>
              <a [class.active]="validateRoute('notifications')" (click)="goToRoute('notifications')" *ngIf="isnotification_logsCanAccess">{{'Documents' | translate}}</a>
              <a [class.active]="validateRoute('asset-recovery')" (click)="goToRoute('asset-recovery')" *ngIf="isasset_recoveryCanAccess">{{'Asset Recovery' | translate}}</a>
              <a [class.active]="validateRoute('account-history')" (click)="goToRoute('account-history')" *ngIf="isaccount_historyCanAccess">{{'Account History' | translate}}</a>
            </div>
          </div>
        </div>
      </div>
</div>

</div>
</div>
<div class="row flex-nowrap no-gutters">
  <div class="col-auto sidebar">
    <div class="page-navbar queue-sidebar collapse show" id="sidebar">
      <div class="applicant-sidebar" [ngClass]="isAssetRecoverySection ? 'yellow-heading' : ''">
        <div class="module-sidebar-heading module-success">
          <img class="menu-icon icon-light" src="../assets/images/sidebar/service-dark.png" alt="" />
          <img class="menu-icon icon-dark" src="../assets/images/sidebar/service.png" alt="" />
          {{'Work Screens'|translate}}
        </div>
        <div class="row mx-0 gutters-8 justify-content-between align-items-center sidebar-actions">
          <div class="col-auto" (click)="goBack()" *ngIf="queuesAccess">
            <a href="javascript:void(0);" class="btn p-0 btn-sidebar-queue">
              <img class="icon-dark mr-2" src="../assets/images/icons/prev-circle-dark.png" alt="" aria-hidden="true" />
              <img class="icon-light mr-2" src="../assets/images/icons/prev-circle.png" alt="" aria-hidden="true" />
              {{'Queue'|translate}}
            </a>
          </div>
          <div class="col-auto">
            <a href="javascript:void(0);" [class.disabled]="this.is_next_Disable" class="btn p-0 btn-sidebar-next" *ngIf="nextLoanIDCnter <= nextLoanTotalSize" (click)="getQueuesLoanList()">
              {{'Next'|translate}}
              <img class="icon-dark ml-2" src="../assets/images/icons/next-circle-dark.png" alt="" aria-hidden="true" />
              <img class="icon-light ml-2" src="../assets/images/icons/next-circle.png" alt="" aria-hidden="true" />
            </a>
          </div>
        </div>
        <div [hidden]="!viewNextAction" class="row mx-0 gutters-8 align-items-center sidebar-outbound-call">
          <div class="col-auto">
            <span class="font-size-14 w-40 d-inline-block text-center">{{'Next Action'|translate}}</span>
          </div>
          <div class="col">
            <a href="javascript:void(0);" class="btn btn-block btn-outbound-call">{{loanDetail?.sub_status_next_action_title??''}}</a>
          </div>
        </div>
        <ngb-accordion [closeOthers]="false"
          activeIds="sidebar-loan-detail, best-time-to-call sidebar-loan-history, sidebar-loan-activity, sidebar-routing, sidebar-agents-assigned">
          <!-- Loan Details -->
          <ngb-panel id="sidebar-loan-detail">
            <ng-template ngbPanelTitle> {{'Loan Details'| translate}} </ng-template>
            <ng-template ngbPanelContent>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Loan Type'| translate}}</div>
                <div class="col-6 text-right">
                  {{ loanDetail?.loan_type }}
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Collateral Type'| translate}}</div>
                <div class="col-6 text-right">
                  <!-- {{ loanDetail?.collateral?.collateral_type | titleCase }} -->
                  {{collateral_type[(loanDetail?.collateral?.collateral_type || "")] || ''}}
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Portfolio Name'| translate}}</div>
                <div class="col-6 text-right">
                  {{ loanDetail?.portfolio_name }}
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Status Code' | translate}}</div>
                <div class="col-6 text-right">{{loanDetail?.status?.toUpperCase().substr(0,1)||''}}{{loanDetail?.dq_bucket || "0"}}{{loanDetail?.sub_status|| ''}}</div>
              </div>
              <div class="row gutters-8">
                <div class="col-md-12 text-right">
                  <div class="underline-text">{{'Status / Last Update' | translate}}</div>
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right text-success-light">{{ loanDetail?.status ? loanDetail?.status.replace('-', ' ') : '' }} </div>
                <div class="col-6 text-right"> {{convertLocalTimeZone( loanDetail?.status_last_update_date) | date: DATE_FORMAT_MMDDYYYY  }}</div>
              </div>
              <div  class="row gutters-8">
                <div class="col-6 text-right text-success-light">  {{ (loanDetail?.sub_status_label|| '') }}</div>
                <div class="col-6 text-right" *ngIf="loanDetail?.sub_status_label">
                  {{convertLocalTimeZone(loanDetail?.sub_status_last_update_date) | date: DATE_FORMAT_MMDDYYYY}}
                </div>
              </div>
              <div class="row gutters-8 my-2">
                <div class="col-6 text-right">

                 <div *ngIf="RiskGradePermission || CollectiveGradePermission">
                  {{
                    isAssetRecoverySection
                    ? (CollectiveGradePermission==true?('Collectability Grade'|translate):'')
                    :(RiskGradePermission==true? ('Risk Grade'|translate) :'')
                    }}
                </div>
                </div>
                <div *ngIf="RiskGradePermission || CollectiveGradePermission" class="col-6 text-right text-danger font-weight-bold font-size-20">
                  {{
                  isAssetRecoverySection
                  ? (CollectiveGradePermission==true?loanDetail?.risk_grade_pbar:'')
                  :(RiskGradePermission==true?loanDetail?.risk_grade:'')
                  }}
                </div>
              </div>
              <ngb-accordion [closeOthers]="false" activeIds="NetBalAtRisk, PriBalAtRisk ,CurrentLTV">
                <!-- Principal Bal at Risk -->
                <ngb-panel id="PriBalAtRisk" *ngIf="isAssetRecoverySection && PBARPermission">
                  <ng-template ngbPanelHeader>
                    <div>
                      <button ngbPanelToggle class="btn btn-link btn-toggle-arrow"></button>
                      {{'Principal Balance at Risk'|translate}}
                    </div>
                    <span>{{
                      (loanDetail?.principle_balance_at_risk || 0) | currency
                      }}</span>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="chart-container" *ngIf="chartNetBalAtRiskRender && NBARPermission">
                      <apx-chart [series]="chartNetBalAtRisk.series" [chart]="chartNetBalAtRisk.chart"
                        [colors]="chartNetBalAtRisk.colors" [yaxis]="chartNetBalAtRisk.yaxis"
                        [dataLabels]="chartNetBalAtRisk.dataLabels" [markers]="chartNetBalAtRisk.markers"
                        [stroke]="chartNetBalAtRisk.stroke" [grid]="chartNetBalAtRisk.grid"
                        [xaxis]="chartNetBalAtRisk.xaxis" [tooltip]="chartNetBalAtRisk.tooltip"
                        [theme]="chartNetBalAtRisk.theme"
                        [legend]="chartNetBalAtRisk.legend"
                        ></apx-chart>
                    </div>
                    <div class="chart-container" *ngIf="!chartNetBalAtRiskRender && NBARPermission">
                      <div class="card-form-content card-form-success mt-3">
                        <div class="skeleton skeleton-table"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                      </div>
                    </div>
                    <div class="text-center font-weight-bold font-size-12">
                      {{'Prin Balance'|translate}}
                    </div>
                  </ng-template>
                </ngb-panel>
                <!-- Net Bal at Risk -->
                <ngb-panel id="NetBalAtRisk" *ngIf="!isAssetRecoverySection && NBARPermission">
                  <ng-template ngbPanelHeader>
                    <div>
                      <button ngbPanelToggle class="btn btn-link"></button>
                      {{'Net Balance at Risk'|translate}}
                    </div>
                    <span >{{
                      loanDetail?.net_balance_at_risk | currency
                      }}</span>
                  </ng-template>
                  <ng-template  ngbPanelContent>
                    <div class="chart-container hidden-graph" *ngIf="chartNetBalAtRiskRender">
                      <apx-chart [series]="chartNetBalAtRisk.series" [chart]="chartNetBalAtRisk.chart"
                        [colors]="chartNetBalAtRisk.colors" [yaxis]="chartNetBalAtRisk.yaxis"
                        [dataLabels]="chartNetBalAtRisk.dataLabels" [markers]="chartNetBalAtRisk.markers"
                        [stroke]="chartNetBalAtRisk.stroke" [grid]="chartNetBalAtRisk.grid"
                        [xaxis]="chartNetBalAtRisk.xaxis" [tooltip]="chartNetBalAtRisk.tooltip"
                        [legend]="chartNetBalAtRisk.legend"
                        [theme]="chartNetBalAtRisk.theme"></apx-chart>
                    </div>
                    <div class="chart-container" *ngIf="!chartNetBalAtRiskRender && NBARPermission">
                      <div class="card-form-content card-form-success mt-3">
                        <div class="skeleton skeleton-table"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                        <div class="skeleton skeleton-table-row"></div>
                      </div>
                    </div>
                    <div class="text-center font-weight-bold font-size-12">
                      {{'Net Balance'|translate}}
                    </div>
                    <div class="chart-container">
                        <img class="hide-graph-img" src="../assets/images/scorecard/side-bar-1.png">
                    </div>
                  </ng-template>
                 
                </ngb-panel>
                <!-- Current LTV -->
                <ngb-panel id="CurrentLTV" *ngIf="LTVPermission">
                  <ng-template ngbPanelHeader>
                    <div>
                      <button ngbPanelToggle class="btn btn-link btn-toggle-arrow"></button>
                      {{'Current LTV'|translate}}
                    </div>
                    <span>{{ loanDetail?.current_ltv ??'0.00' }}%</span>
                  </ng-template>
                  <ng-template *ngIf="!ltvChartLoading" ngbPanelContent>
                    <div class="chart-container hidden-graph">
                      <apx-chart *ngIf="chart2options!=null"
                        [series]="chart2options.series"
                        [chart]="chart2options.chart"
                        [colors]="chart2options.colors"
                        [yaxis]="chart2options.yaxis"
                        [dataLabels]="chart2options.dataLabels"
                        [markers]="chart2options.markers"
                        [stroke]="chart2options.stroke"
                        [grid]="chart2options.grid"
                        [xaxis]="chart2options.xaxis"
                        [tooltip]="chart2options.tooltip"
                        [legend]="chart2options.legend"
                        [theme]="chart2options.theme"></apx-chart>
                      <!-- <div class="text-center font-weight-bold font-size-12">Year</div> -->
                    </div>
                    <div class="chart-container">
                        <img class="hide-graph-img" src="../assets/images/scorecard/side-bar-2.png">
                    </div>
                  </ng-template>
                  <ng-template *ngIf="ltvChartLoading" ngbPanelContent>
                    <div class="card-form-content card-form-success mt-3">
                      <div class="skeleton skeleton-table"></div>
                      <div class="skeleton skeleton-table-row"></div>
                      <div class="skeleton skeleton-table-row"></div>
                      <div class="skeleton skeleton-table-row"></div>
                      <div class="skeleton skeleton-table-row"></div>
                      <div class="skeleton skeleton-table-row"></div>
                      <div class="skeleton skeleton-table-row"></div>
                    </div>
                  </ng-template>
                </ngb-panel>
              </ngb-accordion>
            </ng-template>
          </ngb-panel>
          <!-- Best Time to Call -->
          <ngb-panel id="best-time-to-call">
            <ng-template ngbPanelTitle> {{'Best Time to Call'|translate}} </ng-template>
              <ng-template ngbPanelContent>
                <table *ngIf="loanDetail?.best_time_to_call?.applicant" class="table-bordered best-time-call-table">
                    <thead>
                        <th class="main-heading">{{'Applicant'|translate}}</th>
                        <th>{{'Morning'|translate}}</th>
                        <th>{{'Afternoon'|translate}}</th>
                        <th>{{'Evening'|translate}}</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{'Mobile'|translate}}</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.mobile?.M||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.mobile?.A||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.mobile?.E||0}}%</td>
                        </tr>
                        <tr>
                            <td>{{'Home'|translate}}</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.home?.M||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.home?.A||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.home?.E||0}}%</td>
                        </tr>
                        <tr>
                            <td>{{'Work'|translate}}</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.work?.M||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.work?.A||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.applicant?.work?.E||0}}%</td>
                        </tr>
                    </tbody>
                </table>
                <!-- Co-Applicant -->
                <table *ngIf="loanDetail?.best_time_to_call?.coapplicant" class="table-bordered best-time-call-table mt-2">
                    <thead>
                        <th class="main-heading">{{'Co-Applicant'|translate}}</th>
                        <th>{{'Morning'|translate}}</th>
                        <th>{{'Afternoon'|translate}}</th>
                        <th>{{'Evening'|translate}}</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{'Mobile'|translate}}</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.mobile?.M||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.mobile?.A||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.mobile?.E||0}}%</td>
                        </tr>
                        <tr>
                            <td>{{'Home'|translate}}</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.home?.M||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.home?.A||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.home?.E||0}}%</td>

                        </tr>
                        <tr>
                            <td>{{'Work'|translate}}</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.work?.M||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.work?.A||0}}%</td>
                            <td>{{loanDetail?.best_time_to_call?.coapplicant?.work?.E||0}}%</td>

                        </tr>
                    </tbody>
                </table>
            </ng-template>
        </ngb-panel>






          <!-- Loan History -->
          <ngb-panel id="sidebar-loan-history">
            <ng-template ngbPanelTitle> {{'Loan History'|translate}} </ng-template>
            <ng-template ngbPanelContent>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Contract Date'|translate}}</div>
                <div class="col-6 text-right">
                  {{ loanDetail?.contract_date | date: DATE_FORMAT_MMDDYYYY }}
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Origination Date'|translate}}</div>
                <div class="col-6 text-right">
                  {{ loanDetail?.origination_date | date: DATE_FORMAT_MMDDYYYY }}
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Billing Date'|translate}}</div>
                <div class="col-6 text-right">
                  {{ loanDetail?.billing_date | date: DATE_FORMAT_MMDDYYYY }}
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Due Date'|translate}}</div>
                <div class="col-6 text-right">
                  {{ loanDetail?.current_due_date | date: DATE_FORMAT_MMDDYYYY }}
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Days Past Due'|translate}}</div>
                <div class="col-6 text-right">{{ loanDetail?.past_due }}</div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">
                  {{ (isAssetRecoverySection ? 'Collectability Bucket' : 'Delinquency Bucket')|translate}}
                </div>
                <div class="col-6 text-right">{{ loanDetail?.dq_bucket }}</div>
              </div>
              <div class="row gutters-8" *ngIf="!isAssetRecoverySection">

                <div class="col-6 text-right">{{'Amount Due'|translate}}</div>

                <div class="col-6 text-right">{{ ( loanDetail?.current_amount_due || "0.00") | currency}}</div>



              </div>
              <div class="row gutters-8" *ngIf="!isAssetRecoverySection">
                <div class="col-6 text-right">{{'Total Amount Due'|translate}}</div>
                <div class="col-6 text-right">

                  {{ ((loanDetail?.payment_info_total_amount_due  )|| "0.00")  | currency}}


                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Compliance State'|translate}}</div>
                <div class="col-6 text-right">{{ loanDetail?.communications_limit_state }}</div>
              </div>

              <div class="row gutters-8 align-items-center mt-2">
                <div class="col-6 text-right">
                  <div class="">{{'Last Notification'|translate}}</div>
                </div>
                <div class="col-6 text-right">
                  <div class=" text-success-light">
                    {{loanDetail?.latest_notification?.notification==null?
                    (loanDetail?.latest_notification?.email_subject_1):(loanDetail?.latest_notification?.notification?.name)}}
                  </div>
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Last Notif Date'|translate}}</div>
                <div class="col-6 text-right">{{(convertLocalTimeZone(loanDetail?.latest_notification?.created_at))| date: DATE_FORMAT_MMDDYYYY||''}}</div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Last RPC Date'|translate}}</div>
                <div class="col-6 text-right">{{(convertLocalTimeZone(loanDetail?.last_rpc_date))| date: DATE_FORMAT_MMDDYYYY||''}}</div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Cash Position'|translate}}</div>
                <div class="col-6 text-right">
                  {{ (((  this.loanDetail?.account_current_principal_paid || 0  )+( this.loanDetail?.account_current_interest_paid || 0 )+(current_fee_balance_paid||0))-(loanDetail?.check_to_client||0))  | currency }}
                </div>
              </div>



            </ng-template>
          </ngb-panel>
          <!-- Loan Activity -->
          <ngb-panel id="sidebar-loan-activity">
            <ng-template ngbPanelTitle> {{'Loan Activity'|translate}} </ng-template>
            <ng-template ngbPanelContent>
              <div class="row gutters-8 align-items-center">
                <div class="col-6 text-right">
                  <div class="">{{'Priority Status'|translate}}</div>
                </div>
                <div class="col-6 text-right">
                  <div class="font-size-12 text-yellow">
                    <!-- {{ loanDetail?.latest_activity?.note }} -->
                    {{loanDetail?.account_work_activity_priority_status}}
                  </div>
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Last Worked Date'|translate}}</div>
                <div class="col-6 text-right">
                  {{convertLocalTimeZone(loanDetail?.account_last_worked_date) | date: DATE_FORMAT_MMDDYYYY}}
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Last PTP Date'|translate}}</div>
                <div class="col-6 text-right">
                  {{ convertLocalTimeZone(loanDetail?.account_work_activity_last_ptp_date)  | date: DATE_FORMAT_MMDDYYYY}}
                </div>
              </div>
            </ng-template>
          </ngb-panel>
          <!-- Routing -->
          <ngb-panel id="sidebar-routing">
            <ng-template ngbPanelTitle> {{'Routing'|translate}} </ng-template>
            <ng-template ngbPanelContent>
              <div class="row gutters-8 align-items-center">
                <div class="col-6 text-right">{{'Route To'|translate}}</div>
                <div class="col-6 text-right">
                  <span class="border-bottom border-success-light">
                    {{ loanDetail?.routed?.employee_initials }}
                  </span>
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-md-12 text-right">
                  <div class="font-size-12 text-success-light">
                    {{ loanDetail?.routed?.firstname }}
                    {{ loanDetail?.routed?.lastname }}
                  </div>
                </div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Last Route Date'|translate}}</div>
                <div class="col-6 text-right">{{(convertLocalTimeZone(loanDetail?.last_route_date))| date: DATE_FORMAT_MMDDYYYY}}</div>
              </div>
              <div class="row gutters-8">
                <div class="col-6 text-right">{{'Last Route Time'|translate}}</div>
                <div class="col-6 text-right">{{(convertLocalTimeZone(loanDetail?.last_route_date))| date: 'mediumTime'}}</div>
              </div>
              <div class="row gutters-8">
                <div class="col-md-12 text-right">
                  <a href="javascript:void(0);" class="underline-text blue" (click)="openRouteAccountModal(RouteAccount,true)">
                    {{'Routing History'|translate}}
                  </a>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
          <!-- Agents Assigned -->
          <ngb-panel id="sidebar-agents-assigned">
            <ng-template ngbPanelTitle> {{'Agents Assigned'|translate}} </ng-template>
            <ng-template ngbPanelContent>
              <!-- <div class="row gutters-8 align-items-center" *ngFor="let item of assignmentHistory">
                <div class="col-6 text-right">
                  {{item?.department_name}}
                </div>
                <div class="col-6 text-right">{{item.employee_initials}}</div>
              </div> -->
              <div class="row gutters-8 align-items-center" >
                <div class="col-6 text-right">
                  <label class="gray"><span class="border-bottom border-success-light">{{'Department'|translate}}</span></label><br/>
                  {{loanDetail?.assignee?.department?.label}}
                </div>
                <div class="col-6 text-right">
                  <label class="gray"><span class="border-bottom border-success-light">{{'Initials'|translate}}</span></label><br/>
                  {{loanDetail?.assignee?.employee_initials}}
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="main-page-wrapper">
      <div class="lms-card lms-card-dark mb-3 pb-2">
        <h3 class="lms-card-heading" [ngClass]="
            isAssetRecoverySection
              ? 'module-heading-yellow'
              : 'module-heading-success'
          ">
          {{ sectionTitle | translate}}
        </h3>
        <div class="row align-items-end">
          <div class="col-lg">

            <!-- <div class="col-sm-5">
              {{'select'}}
              <ng-select
              class="form-control form-control-sm pl-2 w-75"
              ngDefaultControl
              [items]="chartOptions"
              [multiple]="false"
              [closeOnSelect]="true"
              [searchable]="false"
              bindLabel="label"
              bindValue="value"
              placeholder="Select Chart"
              [(ngModel)]="selectedChart">
             </ng-select>
             </div> -->
            <div class="row m-2" *ngIf="currentActivity">

                <div class="col-md-3 p-0  activty-box">
                  <span>{{'Last activity note'|translate}}</span>

                  <div class="d-inline-flex align-items-center ml-3">
                    <button type="button" class="btn btn-link btn-version-prev px-0" [disabled]="activityPageCnter <= 1"
                      (click)="goToActivity('PREV')">
                      <img src="../assets/images/icons/save-arrow-prev.png" alt="" />
                    </button>
                    <button type="button" class="btn btn-link btn-version-next px-0"
                      [disabled]="activityPageCnter >= activityTotalSize" (click)="goToActivity('NEXT')">
                      <img src="../assets/images/icons/save-arrow-next.png" alt="" />
                    </button>
                  </div>
                </div>
                <div class="col-md-9 p-0">
                  <div class="module-msg-description" *ngIf="currentActivity!=null">
                    {{ currentActivity.activity_type.title }} : <span class="note-content">{{ truncatedNote }}</span>
                    <!-- "View More" / "See Less" link -->
                    <span><a href="javascript:void(0)" class="text-nowrap text-capitalize" *ngIf="currentActivity.note.length > 200"
                      (click)="toggleNoteDisplay()">
                      {{ showFullNote ? ('View Less' | translate) : ('View More' | translate) }}
                    </a></span>
                    {{ currentActivity ? "-" : "" }}
                    {{ getAgentName() }}
                    <!-- {{ currentActivity.activity_note_agent  ? (currentActivity.activity_note_agent?.firstname | titlecase) +' '+(currentActivity.activity_note_agent?.lastname | titlecase) : ((currentActivity.activity_note_agent_id ) ?? 'System')}} -->
                    {{ convertLocalTimeZone(currentActivity.activity_at) | date:'shortDate' }}
                  </div>
                </div>

            </div>
            <div class="col-md-2 p-0">
              <span>
                <select (change)="chartTypeChange($event)"  id="chart_type" name="chart_type"  class="form-control form-control-sm pl-2 w-75">
                  <option value="act"> {{'Activity Chart'|translate}} </option>
                  <option value="pmts"> {{'Pmts View'|translate}} </option>
                  <option value="buckets"> {{'Buckets View'|translate}} </option>
                </select>

                </span>

            </div>

          </div>
          <div class="col-lg-auto">
            <div>
              <button type="button" class="module-btn-shadow" *ngIf="activityNotePermission" (click)="openAddNoteModal()">
                <span>
                  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21.85 13.84V1.63C21.85 0.3 21.54 0 20.17 0H1.66C1.47 0 1.27 0 1.07 0C0.801201 0.0351761 0.551551 0.158169 0.359861 0.34986C0.16817 0.541551 0.0451767 0.7912 0.0100006 1.06C8.51881e-06 1.25654 8.51881e-06 1.45346 0.0100006 1.65V13.75C-7.83317e-05 13.9465 -7.83317e-05 14.1435 0.0100006 14.34C0.0700006 15.1 0.410001 15.43 1.15 15.44H13.21C14.4919 17.0705 15.9583 18.547 17.58 19.84V15.44H20.73C20.871 15.4571 21.0141 15.4439 21.1496 15.4013C21.2852 15.3587 21.4101 15.2878 21.516 15.1932C21.622 15.0986 21.7066 14.9824 21.7642 14.8526C21.8218 14.7227 21.851 14.5821 21.85 14.44C21.865 14.2403 21.865 14.0397 21.85 13.84ZM11.65 8.29V11.38H10.26V8.31H7.16V6.92H10.16V3.85H11.55C11.6177 4.32352 11.6344 4.80292 11.6 5.28C11.6 5.79 11.6 6.28 11.6 6.85H14.6C14.79 7.34 14.6 7.85 14.72 8.29H11.65Z"
                      fill="#FEFEFE" />
                  </svg>
                </span>
                {{'New Note'|translate}}
              </button>
              <button   *ngIf="TakePaymentPermissionType()!='NO'"   type="button" class="module-btn-shadow" (click)="openTakePaymentTypeModal('')">
                <span>
                  <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21.62 1.74015C21.62 0.48015 21.13 -0.00985027 19.91 0.000149731C16.91 0.000149731 13.85 0.000149731 10.83 0.000149731C7.81 0.000149731 4.69 0.000149731 1.62 0.000149731C0.529999 0.000149731 -0.010001 0.41015 -9.65447e-07 1.60015C0.039999 5.60015 0.039999 9.60015 -9.65447e-07 13.6002C-9.65447e-07 14.8502 0.579999 15.2302 1.7 15.2202C7.76 15.2202 13.82 15.2202 19.87 15.2202C21.08 15.2202 21.64 14.7901 21.62 13.5101C21.5733 9.57015 21.5733 5.64682 21.62 1.74015ZM19.92 13.4502H1.69V9.25015H19.92V13.4502ZM19.92 5.90015H1.7V1.73015H19.93L19.92 5.90015Z"
                      fill="#FEFEFE" />
                    <path d="M3.28 11.8499V10.9199H7.48V11.8499H3.28Z" fill="#FEFEFE" />
                    <path d="M8.69 10.8896H10.69V11.8896H8.69V10.8896Z" fill="#FEFEFE" />
                  </svg>
                </span>
                {{'Take Pmt'|translate}}
              </button>
              <div class="dropdown tools-dropdowns d-inline-block" >
                 <button class="module-btn-shadow" type="button" id="tools-dropdowns" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <span>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                          d="M20.0455 9.16118C20.0546 9.04777 20.0265 8.9345 19.9655 8.83858C19.9045 8.74267 19.814 8.66936 19.7076 8.6298C19.1323 8.40992 18.6848 8.17172 18.219 7.93351C18.1238 7.8911 18.0392 7.828 17.9713 7.74878C17.9034 7.66956 17.8539 7.57619 17.8263 7.47543C17.6988 7.05101 17.5242 6.64228 17.3058 6.25692C17.2558 6.16684 17.2259 6.06697 17.218 5.96418C17.2101 5.86139 17.2245 5.7581 17.2601 5.66141C17.4428 5.14835 17.598 4.62614 17.7807 4.11308C17.8253 4.01384 17.8361 3.9026 17.8114 3.79659C17.7866 3.69058 17.7277 3.59572 17.6437 3.52673C17.2419 3.13278 16.84 2.72966 16.4473 2.32655C16.3774 2.24386 16.2823 2.18652 16.1767 2.16334C16.0711 2.14017 15.9608 2.15244 15.8629 2.19828C15.3606 2.37236 14.8492 2.52811 14.3469 2.71134C14.2496 2.75649 14.1436 2.77988 14.0364 2.77988C13.9292 2.77988 13.8232 2.75649 13.7259 2.71134C13.3174 2.49162 12.8894 2.31065 12.4473 2.1708C12.3469 2.14197 12.2547 2.08953 12.1785 2.01783C12.1022 1.94613 12.0441 1.85724 12.009 1.75852C11.7807 1.27295 11.5341 0.842352 11.3058 0.310973C11.2689 0.21396 11.202 0.13136 11.1149 0.0752969C11.0278 0.0192339 10.9251 -0.00733999 10.8218 -0.000524507H9.08662C8.98988 -0.0107147 8.89252 0.0116604 8.80985 0.063078C8.72719 0.114496 8.66391 0.192035 8.63 0.283488C8.40169 0.77822 8.17338 1.24547 7.9268 1.75852C7.8824 1.86303 7.81496 1.95608 7.72954 2.03066C7.64412 2.10525 7.54295 2.15943 7.43365 2.18912C7.0179 2.30523 6.61657 2.46813 6.2373 2.67469C6.15078 2.72865 6.05295 2.76171 5.95152 2.77125C5.85009 2.78079 5.74784 2.76655 5.65283 2.72966L4.16424 2.21661L3.90854 2.14331C3.85106 2.1408 3.79381 2.15193 3.74144 2.17581C3.68907 2.19969 3.64307 2.23565 3.60717 2.28074L2.28297 3.59086C2.21414 3.65258 2.16649 3.73452 2.14681 3.825C2.12713 3.91548 2.13643 4.00989 2.17338 4.09476C2.34689 4.59865 2.50214 5.11171 2.68479 5.6156C2.73336 5.7316 2.75451 5.8573 2.74659 5.98286C2.73866 6.10842 2.70189 6.23044 2.63913 6.33937C2.43383 6.71166 2.26852 7.10476 2.14598 7.51207C2.11649 7.61465 2.06419 7.70917 1.993 7.78852C1.92181 7.86787 1.83361 7.92997 1.73502 7.97016C1.251 8.1992 0.821778 8.45573 0.292098 8.68477C0.200135 8.71853 0.121749 8.78162 0.0689609 8.86436C0.0161733 8.94711 -0.00810104 9.04494 -0.000139382 9.14286C-0.000139382 9.71088 -0.000139382 10.2789 -0.000139382 10.8469C-0.00737663 10.9541 0.0197356 11.0609 0.0772389 11.1515C0.134742 11.2422 0.219625 11.312 0.319495 11.3508C0.794381 11.5707 1.23274 11.8181 1.73502 12.0471C1.83461 12.0882 1.92346 12.1517 1.99471 12.2328C2.06596 12.3138 2.11772 12.4101 2.14598 12.5144C2.27784 12.9445 2.46187 13.3569 2.69392 13.742C2.73893 13.8397 2.76225 13.946 2.76225 14.0535C2.76225 14.1611 2.73893 14.2674 2.69392 14.365C2.51128 14.8872 2.34689 15.4186 2.16424 15.9408C2.12219 16.0353 2.11191 16.1409 2.13498 16.2417C2.15804 16.3426 2.2132 16.4331 2.2921 16.4997C2.69392 16.8937 3.08662 17.2784 3.47018 17.6816C3.54343 17.7681 3.64277 17.8283 3.75318 17.8531C3.86358 17.8779 3.97903 17.8659 4.08205 17.819C4.59347 17.6358 5.11402 17.4708 5.63456 17.2968C5.72769 17.254 5.82893 17.2318 5.93137 17.2318C6.03381 17.2318 6.13504 17.254 6.22817 17.2968C6.63694 17.5159 7.06492 17.6968 7.50671 17.8373C7.59815 17.866 7.68269 17.9134 7.75498 17.9764C7.82728 18.0395 7.88578 18.1169 7.9268 18.2038C8.16424 18.6985 8.41995 19.1841 8.65739 19.6697C8.69075 19.7628 8.75326 19.8425 8.83557 19.897C8.91788 19.9515 9.01557 19.9778 9.11401 19.972C9.72284 19.972 10.3073 19.972 10.8674 19.972C10.966 19.979 11.0643 19.9544 11.148 19.9017C11.2318 19.849 11.2966 19.7709 11.3332 19.6788C11.5615 19.1932 11.8172 18.7626 12.0455 18.2404C12.0887 18.1361 12.1559 18.0435 12.2416 17.9702C12.3273 17.897 12.4291 17.8451 12.5387 17.819C12.9278 17.7017 13.3018 17.5387 13.6528 17.3334C13.7678 17.2651 13.8974 17.2253 14.0309 17.2174C14.1643 17.2094 14.2977 17.2335 14.42 17.2876C14.8948 17.4617 15.3789 17.5991 15.8537 17.7732C15.9611 17.821 16.0813 17.8317 16.1954 17.8035C16.3094 17.7753 16.4109 17.7098 16.4839 17.6174C16.8553 17.2265 17.2388 16.8417 17.6346 16.4631C17.7197 16.3949 17.7788 16.2994 17.8021 16.1926C17.8254 16.0859 17.8114 15.9743 17.7624 15.8767C17.5798 15.3545 17.4154 14.8231 17.2327 14.3009C17.1994 14.2084 17.1862 14.1099 17.1941 14.0119C17.202 13.9139 17.2307 13.8188 17.2784 13.7329C17.5015 13.3262 17.6791 12.896 17.8081 12.4502C17.8341 12.3512 17.8821 12.2594 17.9485 12.1816C18.0149 12.1039 18.0981 12.0422 18.1916 12.0013C18.6848 11.7631 19.1597 11.5066 19.6528 11.2684C19.7545 11.2321 19.8411 11.1628 19.899 11.0716C19.9569 10.9803 19.9828 10.8722 19.9725 10.7645C19.9907 10.2514 19.9816 9.71088 20.0455 9.16118ZM9.99986 13.5313C9.3037 13.5349 8.62213 13.3312 8.04153 12.9458C7.46094 12.5604 7.00744 12.0108 6.73852 11.3666C6.4696 10.7224 6.39736 10.0126 6.53096 9.32722C6.66456 8.6418 6.99797 8.01159 7.48896 7.51646C7.97994 7.02133 8.60639 6.68357 9.28892 6.54598C9.97144 6.40838 10.6793 6.47716 11.3229 6.74358C11.9664 7.01 12.5166 7.46208 12.9037 8.04253C13.2909 8.62297 13.4976 9.30565 13.4976 10.0041C13.4952 10.9356 13.1265 11.8287 12.4716 12.4891C11.8167 13.1496 10.9284 13.5241 9.99986 13.5313Z"
                          fill="white" />
                      </svg>
                      </span>
                      {{'Tools'|translate}}
                  </button>
                <div class="dropdown-menu" aria-labelledby="tools-dropdowns">
                  <button class="dropdown-item" *ngIf="isExtPermission" (click)="openProcessExtensionModal()">{{'Process Extension'|translate}} </button>
                  <button class="dropdown-item" *ngIf="waivePermission" (click)="openWaiveFeesModal(WaiveFees)">{{'Adjust Fee Balances'|translate}}</button>
                  <button class="dropdown-item" *ngIf="isReamortizePermission" (click)="openReamortizeLoanModal()"> {{'Reamortize Loan'|translate}} </button>
                  <button class="dropdown-item" *ngIf="isDueDatePermission"(click)="openDueDateLoanModal()"> {{'Due Date Change'|translate}} </button>
                  <button class="dropdown-item" *ngIf="isRoutedPermission" (click)="openRouteAccountModal(RouteAccount)"> {{'Route Account'|translate}} </button>
                  <button class="dropdown-item" *ngIf="isRepoPermission && ( lastRepoReviewDate=='No' ||  submitRepoReviewStatus==1)"  (click)="openSubmitRepoReviewModal(SubmitRepoReview)"> {{'Submit Repo Review'|translate}} </button>
                  <button class="dropdown-item" *ngIf="manualChargeOffLoans && loanDetail?.status=='ACTIVE'" (click)="openManualChargeOffModal(manualChargeOffLoans)"> {{'Manual Charge Off'|translate}} </button>
                  <button class="dropdown-item" *ngIf="loanDetail?.interest_accrual_on_yn=='YES'" (click)="openModalStartStopInterestAccrual()"> {{'Stop Interest Accrual'|translate}} </button>
                  <button class="dropdown-item" *ngIf="loanDetail?.interest_accrual_on_yn=='NO'" (click)="openModalStartStopInterestAccrual()"> {{'Start Interest Accrual'|translate}} </button>
                  <button class="dropdown-item" *ngIf="loanDetail?.late_fee_accrual_on_yn=='YES'" (click)="openModalStartStopLateFeeAccrual()"> {{'Stop Fee Accrual'|translate}} </button>
                  <button class="dropdown-item" *ngIf="loanDetail?.late_fee_accrual_on_yn=='NO'" (click)="openModalStartStopLateFeeAccrual()"> {{'Start Fee Accrual'|translate}} </button>
                  <button *ngIf="(lastRepoReviewDate=='Yes' &&  submitRepoReviewStatus==2)||(lastRepoReviewDate=='Yes' &&  this.loanDetail?.latest_kickback_repo_review==null)" class="dropdown-item"
                    (click)="openKickbackRepoReviewModal(KickbackRepoReviewModal)">{{'Kickback Repo Review'|translate}}</button>
                </div>
              </div>
              <!-- <div ngbDropdown class="tools-dropdowns d-inline-block" >
                <button type="button" id="tools-dropdowns" ngbDropdownToggle class="module-btn-shadow">
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M20.0455 9.16118C20.0546 9.04777 20.0265 8.9345 19.9655 8.83858C19.9045 8.74267 19.814 8.66936 19.7076 8.6298C19.1323 8.40992 18.6848 8.17172 18.219 7.93351C18.1238 7.8911 18.0392 7.828 17.9713 7.74878C17.9034 7.66956 17.8539 7.57619 17.8263 7.47543C17.6988 7.05101 17.5242 6.64228 17.3058 6.25692C17.2558 6.16684 17.2259 6.06697 17.218 5.96418C17.2101 5.86139 17.2245 5.7581 17.2601 5.66141C17.4428 5.14835 17.598 4.62614 17.7807 4.11308C17.8253 4.01384 17.8361 3.9026 17.8114 3.79659C17.7866 3.69058 17.7277 3.59572 17.6437 3.52673C17.2419 3.13278 16.84 2.72966 16.4473 2.32655C16.3774 2.24386 16.2823 2.18652 16.1767 2.16334C16.0711 2.14017 15.9608 2.15244 15.8629 2.19828C15.3606 2.37236 14.8492 2.52811 14.3469 2.71134C14.2496 2.75649 14.1436 2.77988 14.0364 2.77988C13.9292 2.77988 13.8232 2.75649 13.7259 2.71134C13.3174 2.49162 12.8894 2.31065 12.4473 2.1708C12.3469 2.14197 12.2547 2.08953 12.1785 2.01783C12.1022 1.94613 12.0441 1.85724 12.009 1.75852C11.7807 1.27295 11.5341 0.842352 11.3058 0.310973C11.2689 0.21396 11.202 0.13136 11.1149 0.0752969C11.0278 0.0192339 10.9251 -0.00733999 10.8218 -0.000524507H9.08662C8.98988 -0.0107147 8.89252 0.0116604 8.80985 0.063078C8.72719 0.114496 8.66391 0.192035 8.63 0.283488C8.40169 0.77822 8.17338 1.24547 7.9268 1.75852C7.8824 1.86303 7.81496 1.95608 7.72954 2.03066C7.64412 2.10525 7.54295 2.15943 7.43365 2.18912C7.0179 2.30523 6.61657 2.46813 6.2373 2.67469C6.15078 2.72865 6.05295 2.76171 5.95152 2.77125C5.85009 2.78079 5.74784 2.76655 5.65283 2.72966L4.16424 2.21661L3.90854 2.14331C3.85106 2.1408 3.79381 2.15193 3.74144 2.17581C3.68907 2.19969 3.64307 2.23565 3.60717 2.28074L2.28297 3.59086C2.21414 3.65258 2.16649 3.73452 2.14681 3.825C2.12713 3.91548 2.13643 4.00989 2.17338 4.09476C2.34689 4.59865 2.50214 5.11171 2.68479 5.6156C2.73336 5.7316 2.75451 5.8573 2.74659 5.98286C2.73866 6.10842 2.70189 6.23044 2.63913 6.33937C2.43383 6.71166 2.26852 7.10476 2.14598 7.51207C2.11649 7.61465 2.06419 7.70917 1.993 7.78852C1.92181 7.86787 1.83361 7.92997 1.73502 7.97016C1.251 8.1992 0.821778 8.45573 0.292098 8.68477C0.200135 8.71853 0.121749 8.78162 0.0689609 8.86436C0.0161733 8.94711 -0.00810104 9.04494 -0.000139382 9.14286C-0.000139382 9.71088 -0.000139382 10.2789 -0.000139382 10.8469C-0.00737663 10.9541 0.0197356 11.0609 0.0772389 11.1515C0.134742 11.2422 0.219625 11.312 0.319495 11.3508C0.794381 11.5707 1.23274 11.8181 1.73502 12.0471C1.83461 12.0882 1.92346 12.1517 1.99471 12.2328C2.06596 12.3138 2.11772 12.4101 2.14598 12.5144C2.27784 12.9445 2.46187 13.3569 2.69392 13.742C2.73893 13.8397 2.76225 13.946 2.76225 14.0535C2.76225 14.1611 2.73893 14.2674 2.69392 14.365C2.51128 14.8872 2.34689 15.4186 2.16424 15.9408C2.12219 16.0353 2.11191 16.1409 2.13498 16.2417C2.15804 16.3426 2.2132 16.4331 2.2921 16.4997C2.69392 16.8937 3.08662 17.2784 3.47018 17.6816C3.54343 17.7681 3.64277 17.8283 3.75318 17.8531C3.86358 17.8779 3.97903 17.8659 4.08205 17.819C4.59347 17.6358 5.11402 17.4708 5.63456 17.2968C5.72769 17.254 5.82893 17.2318 5.93137 17.2318C6.03381 17.2318 6.13504 17.254 6.22817 17.2968C6.63694 17.5159 7.06492 17.6968 7.50671 17.8373C7.59815 17.866 7.68269 17.9134 7.75498 17.9764C7.82728 18.0395 7.88578 18.1169 7.9268 18.2038C8.16424 18.6985 8.41995 19.1841 8.65739 19.6697C8.69075 19.7628 8.75326 19.8425 8.83557 19.897C8.91788 19.9515 9.01557 19.9778 9.11401 19.972C9.72284 19.972 10.3073 19.972 10.8674 19.972C10.966 19.979 11.0643 19.9544 11.148 19.9017C11.2318 19.849 11.2966 19.7709 11.3332 19.6788C11.5615 19.1932 11.8172 18.7626 12.0455 18.2404C12.0887 18.1361 12.1559 18.0435 12.2416 17.9702C12.3273 17.897 12.4291 17.8451 12.5387 17.819C12.9278 17.7017 13.3018 17.5387 13.6528 17.3334C13.7678 17.2651 13.8974 17.2253 14.0309 17.2174C14.1643 17.2094 14.2977 17.2335 14.42 17.2876C14.8948 17.4617 15.3789 17.5991 15.8537 17.7732C15.9611 17.821 16.0813 17.8317 16.1954 17.8035C16.3094 17.7753 16.4109 17.7098 16.4839 17.6174C16.8553 17.2265 17.2388 16.8417 17.6346 16.4631C17.7197 16.3949 17.7788 16.2994 17.8021 16.1926C17.8254 16.0859 17.8114 15.9743 17.7624 15.8767C17.5798 15.3545 17.4154 14.8231 17.2327 14.3009C17.1994 14.2084 17.1862 14.1099 17.1941 14.0119C17.202 13.9139 17.2307 13.8188 17.2784 13.7329C17.5015 13.3262 17.6791 12.896 17.8081 12.4502C17.8341 12.3512 17.8821 12.2594 17.9485 12.1816C18.0149 12.1039 18.0981 12.0422 18.1916 12.0013C18.6848 11.7631 19.1597 11.5066 19.6528 11.2684C19.7545 11.2321 19.8411 11.1628 19.899 11.0716C19.9569 10.9803 19.9828 10.8722 19.9725 10.7645C19.9907 10.2514 19.9816 9.71088 20.0455 9.16118ZM9.99986 13.5313C9.3037 13.5349 8.62213 13.3312 8.04153 12.9458C7.46094 12.5604 7.00744 12.0108 6.73852 11.3666C6.4696 10.7224 6.39736 10.0126 6.53096 9.32722C6.66456 8.6418 6.99797 8.01159 7.48896 7.51646C7.97994 7.02133 8.60639 6.68357 9.28892 6.54598C9.97144 6.40838 10.6793 6.47716 11.3229 6.74358C11.9664 7.01 12.5166 7.46208 12.9037 8.04253C13.2909 8.62297 13.4976 9.30565 13.4976 10.0041C13.4952 10.9356 13.1265 11.8287 12.4716 12.4891C11.8167 13.1496 10.9284 13.5241 9.99986 13.5313Z"
                        fill="white" />
                    </svg>
                  </span>
                  Tools
                </button>
                <div ngbDropdownMenu aria-labelledby="tools-dropdowns">
                  <button ngbDropdownItem (click)="openProcessExtensionModal()">
                    Process Extension
                  </button>
                  <button ngbDropdownItem (click)="openWaiveFeesModal(WaiveFees)">
                    Waive Fees
                  </button>
                  <button ngbDropdownItem (click)="openReamortizeLoanModal()">
                    Reamortize Loan
                  </button>
                  <button ngbDropdownItem (click)="openRouteAccountModal(RouteAccount)">
                    Route Account
                  </button>
                  <button ngbDropdownItem (click)="openSubmitRepoReviewModal(SubmitRepoReview)">
                    Submit Repo Review
                  </button>
                  <button *ngIf="
                      loanDetail?.latest_kickback_repo_review?.before
                        ?.sub_status == 'REPO_REVIEW'
                    " ngbDropdownItem (click)="
                      openKickbackRepoReviewModal(KickbackRepoReviewModal)
                    " class="text-warning">
                    Kickback Repo Review
                  </button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="lsm-card-graph mb-3" id="show-graph" >
          <div class="row align-items-top">
            <div class="col-lg-9 pr-0">
              <div class="chart-container hidden-graph" *ngIf="isActivityChartRender && timeLinePermission">
                <apx-chart *ngIf="activityChartOptions!=null"
                  [series]="activityChartOptions.series"
                  [chart]="activityChartOptions.chart"
                  [xaxis]="activityChartOptions.xaxis"
                  [yaxis]="activityChartOptions.yaxis"
                  [colors]="activityChartOptions.colors"
                  [grid]="activityChartOptions.grid"
                  [dataLabels]="chart2options?.dataLabels"
                  [markers]="activityChartOptions.markers"
                  [fill]="activityChartOptions.fill"
                  [legend]="activityChartOptions.legend"
                  [theme]="activityChartOptions.theme"
                  [tooltip]="activityChartOptions.tooltip"
                  ></apx-chart>
              </div>
              <div class="chart-container hidden-graph" *ngIf="!isActivityChartRender && timeLinePermission">
                <div class="card-form-content card-form-success my-3">
                  <div class="skeleton skeleton-table"></div>
                  <div class="skeleton skeleton-table-row"></div>
                  <div class="skeleton skeleton-table-row"></div>
                  <div class="skeleton skeleton-table-row"></div>
                  <div class="skeleton skeleton-table-row"></div>
                  <div class="skeleton skeleton-table-row"></div>
                  <div class="skeleton skeleton-table-row"></div>
                  <div class="skeleton skeleton-table-row"></div>
                  <div class="skeleton skeleton-table-row"></div>
                  <div class="skeleton skeleton-table-row"></div>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="chart-container hidden-graph queue-detail-circle-graph mt-4" *ngIf=" OddsPermission ">
                <!-- <apx-chart [series]="avgChartOptions?.series" [chart]="avgChartOptions?.chart"
                  [dataLabels]="avgChartOptions?.dataLabels" [plotOptions]="avgChartOptions?.plotOptions"
                  [yaxis]="avgChartOptions?.yaxis" [legend]="avgChartOptions?.legend" [fill]="avgChartOptions?.fill"
                  [tooltip]="avgChartOptions?.tooltip" [theme]="avgChartOptions?.theme"></apx-chart> -->
                  <!-- <img class="" src="../assets/images/client/odds roll.png"> -->
                    <div class="circle-graph-block">
                        <div id="dial" class="dial"></div>
                        <div class="circle-div">
                            <p>{{show_avg_odds_of_roll}}%</p>
                        </div>
                    </div>
              </div>
              <!-- <div class="text-align-center mt-3" >Odds Of Roll</div> -->
            </div>

          </div>
        </div>
        <!-- Graph image added -->
        <div class="lsm-card-graph mt-4 hide-graph-img" id="show-graph">
            <img class="hide-graph-img" src="../assets/images/scorecard/queue-home.jpg" width="100%;">
        </div>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- Activity Modal Popup -->
<ng-template #activityModal let-modal>
  <form ngForm [formGroup]="addActivityForm" (ngSubmit)="onActivitySubmit()" novalidate>
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">{{'Activity'|translate}}</h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body py-0">
      <div class="row">
        <div class="form-group col-12">
          <label class="form-group-label">{{'Activity Type'|translate}}</label>
        </div>
        <div class="form-group col-12">
          <select formControlName="activity_type" name="activity_type" class="form-control form-control-sm">
            <option value="">{{'-Select-'|translate}}</option>
            <option *ngFor="let item of activityTypes" [ngValue]="item.id">
              {{ item.label }}
            </option>
          </select>
          <div *ngIf="
              addActivityForm.controls.activity_type.errors?.required &&
              addActivityFormSubmit
            ">
            {{'Activity type is required'|translate}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label class="form-group-label">{{'Activity Note'|translate}}</label>
        </div>
        <div class="form-group col-12">
          <textarea name="note" formControlName="note" class="form-control form-control-sm" value=""></textarea>
          <div *ngIf="
              addActivityForm.controls.note.errors?.required &&
              addActivityFormSubmit
            ">
            {{'Note is required'|translate}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label class="form-group-label">{{'PTP Date'|translate}}</label>
        </div>
        <div class="form-group col-12">
          <app-date-picker formControlName="ptp_date" name="ptp_date"></app-date-picker>
          <div *ngIf="
              addActivityForm.controls.ptp_date.errors?.required &&
              addActivityFormSubmit
            ">
            {{'PTP Date is required'|translate}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label class="form-group-label">{{'PTP Amount'|translate}}</label>
        </div>
        <div class="form-group col-12">
          <input type="number" name="ptp_amount" formControlName="ptp_amount" class="form-control form-control-sm"
            value="" />
          <val-errors controlName="ptp_amount">
            <ng-template valError="required">{{'PTP Amount is required'|translate}}</ng-template>
          </val-errors>
        </div>
      </div>
    </div>
    <div class="modal-footer flex-nowrap">
      <button type="reset" class="btn btn-sm btn-secondary btn-block my-0">
        {{'Cancel'|translate}}
      </button>
      <button type="submit" class="btn btn-sm btn-primary btn-block my-0">
        {{'Save'|translate}}
      </button>
    </div>
  </form>
</ng-template>
<!-- End -->

<!-- Modal Popups -->

<!-- Waive Fees Modal -->
<ng-template #WaiveFees let-modal> </ng-template>

<!-- Submit Repo Review Modal -->
<ng-template #SubmitRepoReview let-modal> </ng-template>

<!-- Override Modal
<ng-template #GetApprovalModal let-modal>
  <div class="modal-body pb-0 px-0">
    <h6 class="modal-title text-center mb-3">Get Approval</h6>
    <div class="lms-module-card">
      <div class="card-body">
        <div class="card-form form-vertical">
          <div class="form-group">
            <label class="form-group-label">Initials</label>
            <input type="text" name="From" class="form-control form-control-sm" value="EB1" />
          </div>
          <div class="form-group">
            <label class="form-group-label">PIN</label>
            <input type="text" name="pin" class="form-control form-control-sm" value="212121" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-block" (click)="modal.close('Close click')">
      Get Approval
    </button>
  </div>
</ng-template> -->

<!-- Route Account Modal -->
<ng-template #RouteAccount let-modal> </ng-template>

<!-- New Note Modal -->
<ng-template #NewNote let-modal>

</ng-template>

<!-- Take Payment Type Modal -->
<!-- <ng-template #TakePaymentType let-modal>
  <div class="draggable-container" cdkDrag cdkDragBoundary=".modal" cdkDragRootElement="draggable-container">
    <div class="draggable-modal-content cursor-pointer" cdkDragHandle>
      <div class="modal-header align-items-center " >
        <h6 class="modal-title modal-title-success">Take Payment</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-0 pt-0">
        <div class="lms-module-card">
          <div class="card-body">
            <div class="card-form-content card-form-success">
              <div class="row align-items-center">
                <div class="col">
                  <a [href]="take_payment_url" *ngIf="take_payment_url!=''" (click)="modal.dismiss('Cross click')" target="_blank" style="color:white;text-decoration:none;">
                  <button type="button" class="btn btn-block btn-success-light" >
                    Go to Payment Portal
                  </button> </a>
                  <a [href]="take_payment_url"  *ngIf="take_payment_url==''" (click)="modal.dismiss('Cross click')" target="_blank" style="color:white;text-decoration:none;pointer-events: none;">
                    <button type="button" [disabled]="true" class="btn btn-block btn-success-light" >
                      Go to Payment Portal
                    </button> </a>

                </div>
                <div class="col-auto">or</div>
                <div class="col">
                  <button type="button" class="btn btn-block btn-success-light"    (click)="openTakePaymentModal(TakePayment)">
                    Input manual payment
                  </button>
                </div>
              </div>
    <!--------------------------------->
    <!-- <br> -->
    <!-- <div class="row align-items-center">
      <div class="col-sm-8">


        <span *ngIf="!this.TakePaymentPermission" class="d-inline-block font-size-14 lms-text-light-pink ml-2">
          You don’t have the permission to route account.
        </span>
      </div>

      <div class="col-sm-2">
        <button *ngIf="!TakePaymentPermission"  type="button" class="btn btn-pink btn-150" (click)="openGetApprovalModal(GetApprovalModalTakePayment)">
          Get Approval
        </button>
      </div>
    </div> -->


    <!------------------------>
<!--
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template> -->

<!-- Take Payment Modal -->
<ng-template #TakePayment let-modal> </ng-template>

<!-- Kickback Repo Review Modal -->
<ng-template #KickbackRepoReviewModal let-modal> </ng-template>





  <!-- Override Modal -->
  <!-- <ng-template #GetApprovalModalTakePayment let-modal>

    <div class="modal-header">
      <h6 class="modal-title text-center mb-3">Get Approval</h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <form #f="ngForm" [formGroup]="appform" (ngSubmit)="verifyPin()" novalidate>
    <div class="modal-body pb-0 px-0">


      <div class="lms-module-card">
        <div class="card-body">
          <div class="card-form form-vertical">
            <div class="form-group">
              <label class="form-group-label">Initials</label>
              <input type="text" name="employee_initials" formControlName="employee_initials" class="form-control form-control-sm" value="EB1" />
              <val-errors controlName="employee_initials">
                <ng-template valError="required">Initial is required</ng-template>
              </val-errors>
            </div>
            <div class="form-group">
              <label class="form-group-label">PIN</label>
              <input type="password" name="pin" formControlName="pin" class="form-control form-control-sm" value="212121" />
              <val-errors controlName="pin">
                <ng-template valError="required">PIN is required</ng-template>
              </val-errors>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" (click)="this.appform.valid ?  modal.dismiss('Cross click') : ''" class="btn btn-primary btn-block">
        Get Approval
      </button>
    </div>
  </form>
  </ng-template> -->
